module.exports = __webpack_public_path__ + "images/emoji/poultry_leg.7c152ad28deb4b319721.png";